<div class="min-h-screen">
  <div
    class="sticky top-0 z-10 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm"
  >
    <div class="px-6 py-5 flex items-center justify-between">
      <div class="flex items-center gap-4">
        <button
          (click)="location.back()"
          class="p-3 rounded-xl bg-gray-100 hover:bg-gray-200 transition"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <div class="flex items-center gap-4">
          <h1
            class="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 !mt-5"
          >
            Subscription #{{ subscription?.subscriptionId || subscription?.id }}
          </h1>

          <span
            class="px-4 py-2 rounded-full text-sm font-bold !mt-1"
            [ngClass]="{
              'bg-green-100 text-green-800': subscription?.isPaid,
              'bg-red-100 text-red-800':
                !subscription?.isPaid &&
                subscription?.bill?.billStatus !== 'PAID',
              'bg-yellow-100 text-yellow-800':
                subscription?.bill?.billStatus === 'WAITING_FOR_PAYMENT',
              'bg-gray-100 text-gray-800':
                subscription?.bill?.billStatus === 'CANCELLED'
            }"
          >
            {{
              subscription?.isPaid
                ? "PAID"
                : subscription?.bill?.billStatus === "WAITING_FOR_PAYMENT"
                ? "Pending"
                : "UNPAID"
            }}
          </span>
          <p class="text-sm text-gray-500 !mt-3">
            Created on: {{ subscription?.createdAt | date : "mediumDate" }}
          </p>
          <span *ngIf="subscription?.endDate" class="text-sm text-gray-500">
            Expires: {{ subscription.endDate | date : "short" }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!loading && subscription"
    class="w-full flex flex-wrap gap-x-16 gap-y-4 my-8"
  >
    <div class="sticky w-full xl:w-[40%] flex flex-col gap-4">
      <!-- <div
        *ngIf="bill.remarks"
        class="bg-amber-50 border border-amber-300 rounded-md p-4 w-full"
      >
        <p class="text-amber-800 font-semibold text-md !mb-0">Note:</p>
        <p class="text-amber-900 text-lg mt-2 !mb-0">{{ bill.remarks }}</p>
      </div> -->
      <div class="border border-gray-300 rounded-md bg-white p-8">
        <div
          class="text-xs font-medium text-gray-500 uppercase tracking-wider pb-2 w-full border-b mb-4"
        >
          Subscriber information
        </div>
        <div class="flex flex-wrap">
          <div class="flex flex-col w-1/2">
            <div
              class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
            >
              Name
            </div>
            <p class="text-lg font-bold text-gray-900 truncate">
              {{ subscription.userAccount.fullName }}
            </p>
          </div>
          <div class="flex flex-col w-1/2">
            <div
              class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
            >
              Phone
            </div>
            <p class="text-lg font-bold text-gray-900 truncate">
              {{ subscription.userAccount.phone }}
            </p>
          </div>
          <div class="flex flex-col w-1/2">
            <div
              class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
            >
              Email
            </div>
            <p class="text-lg font-bold text-gray-900 truncate">
              {{ subscription.userAccount.email }}
            </p>
          </div>
          <div class="flex flex-col w-1/2">
            <div
              class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
            >
              Institution / Company
            </div>
            <p class="text-lg font-bold text-gray-900 truncate">
              {{
                subscription.userAccount.institution ||
                  subscription.userAccount.companyName ||
                  "Individual"
              }}
            </p>
          </div>

          <div
            class="w-full flex flex-wrap border border-primary-100 bg-primary-100/10 p-4 rounded-md"
          >
            <div
              class="text-xs font-medium text-gray-500 uppercase tracking-wider pb-2 w-full border-b my-4"
            >
              Subscription Summary
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Subscription type
              </div>
              <p class="text-lg font-bold text-primary truncate">
                {{
                  subscription.subscriptionType || ""
                    | replace : "_" : " "
                    | titlecase
                }}
              </p>
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Payment Status
              </div>
              <p
                [class]="
                  subscription.isPaid
                    ? 'text-green-700 bg-green-100/10 border-green-100'
                    : 'text-red-700 bg-red-50 border-red-100'
                "
                class="text-md font-bold text-gray-900 truncate rounded-md px-4 py-[2px] w-fit border"
              >
                {{ subscription.isPaid ? "PAID" : "UNPAID" }}
              </p>
            </div>
            <div class="flex flex-col w-full">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Period
              </div>
              <p
                class="text-lg font-bold text-gray-900 truncate flex items-center"
              >
                {{
                  (subscription.startDate | date : "mediumDate") +
                    " &rarr; " +
                    (subscription.endDate | date : "mediumDate")
                }}
              </p>
            </div>
          </div>

          <div
            *ngIf="subscription.bill"
            class="w-full flex flex-wrap bg-gray-100 mt-4 p-4 rounded-md"
          >
            <div
              class="text-xs font-medium text-gray-500 uppercase tracking-wider pb-2 w-full border-b my-4"
            >
              Bill Information
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Bill id
              </div>
              <p class="text-lg font-bold text-primary truncate">
                {{ subscription.bill.billId }}
              </p>
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Control Number
              </div>
              <p
                [class]="
                  subscription.isPaid
                    ? 'text-green-700 bg-green-100/10 border-green-100'
                    : 'text-red-700 bg-red-50 border-red-100'
                "
                class="text-md font-bold text-gray-900 truncate rounded-md px-4 py-[2px] w-fit border"
              >
                {{ subscription.bill.controlNumber || "Not Issued Yet" }}
              </p>
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Payment Method
              </div>
              <p
                class="text-lg font-bold text-gray-900 truncate flex items-center"
              >
                {{ subscription.bill.paymentType | titlecase }}
              </p>
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Bill Amount
              </div>
              <p
                class="text-lg font-bold text-gray-900 truncate flex items-center"
              >
                TZS {{ subscription.bill.totalAmount | number : "1.0-0" }}
              </p>
            </div>
            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Currency
              </div>
              <p
                class="text-lg font-bold text-gray-900 truncate flex items-center"
              >
                {{ subscription.bill.currencyType }}
              </p>
            </div>

            <div class="flex flex-col w-1/2">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Status
              </div>
              <p
                [class]="findStatusClass(subscription.bill.billStatus)"
                class="text-md font-bold text-gray-900 truncate rounded-md px-4 py-[2px] w-fit"
              >
                {{
                  subscription.bill.billStatus | replace : "_" : "" | titlecase
                }}
              </p>
            </div>

            <div class="flex flex-col w-full">
              <div
                class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1"
              >
                Due / Expiry Date
              </div>
              <p
                class="text-lg font-bold text-gray-900 truncate flex items-center"
              >
                {{ subscription.bill.dueDate | date : "fullDate" }}
              </p>
            </div>
            <div class="flex flex-row gap-4 mt-4">
  <!-- View Bill Button -->
  <a
    (click)="onViewBill(subscription.bill.uuid)"
    class="inline-flex items-center gap-2 text-primary font-semibold hover:text-primary-700 cursor-pointer group"
  >
    View Bill
    <svg
      class="w-4 h-4 transition group-hover:translate-x-1"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 5l7 7-7 7"
      />
    </svg>
  </a>

  <!-- Reuse Control Number Button -->
 <button
  *ngIf="subscription?.bill?.controlNumber"
  (click)="onReuseControlNumber(
    subscription?.uuid,
    subscription?.bill?.controlNumber
  )"
  class="inline-flex items-center gap-2 text-primary font-semibold hover:text-primary-700 cursor-pointer group px-4 py-2 rounded-lg border border-primary-200 bg-primary-50 hover:bg-primary-100 transition"
>
  <svg
    class="w-4 h-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    />
  </svg>
  Reuse Control Number
</button>

</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right Column: Subscription Summary -->
    <div class="overflow-hidden flex-1">
      <!-- Subscribed Products Table -->
      <div class="bg-white rounded-lg overflow-hidden border border-gray-200">
        <div
          class="bg-gradient-to-r from-primary to-primary-500 text-white p-4"
        >
          <h3 class="!text-sm !font-semibold uppercase !my-0">
            Subscribed Products
          </h3>
        </div>
        <div class="p-8">
          <table class="w-full">
            <thead class="border-b-2 border-gray-200">
              <tr>
                <th class="text-left py-2 px-6 font-bold text-gray-700">
                  Product
                </th>
                <th class="text-left py-2 px-6 font-bold text-gray-700">
                  Category
                </th>
                <th class="text-left py-2 px-6 font-bold text-gray-700">
                  Rate Card
                </th>
                <th class="text-center py-2 px-6 font-bold text-gray-700">
                  Duration
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of subscription.subscriptionItems"
                class="border-b hover:bg-gray-50"
              >
                <td class="py-2 px-6 font-medium text-gray-900">
                  {{ item.product.title }}
                </td>
                <td class="py-2 px-6 text-gray-700">
                  {{ item.product.productCategory?.title || "—" }}
                </td>
                <td class="py-2 px-6 text-gray-700">
                  {{ item.rateCard.title }}
                </td>
                <td class="text-center py-2 px-6">
                  <span
                    class="inline-flex items-center px-4 py-2 rounded-full text-sm font-bold bg-blue-100 text-blue-800"
                  >
                    {{ item.numberDays }} day{{
                      item.numberDays !== 1 ? "s" : ""
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Not Found -->
  <div *ngIf="!loading && !subscription" class="text-center py-32">
    <p class="text-6xl font-bold text-gray-300">Subscription Not Found</p>
  </div>
</div>
